import { NgModule } from '@angular/core';
import { MyOrdersRoutingModule } from './my-orders-routing.module';
import { SharedModule } from '@app/shared/shared.module';
import * as fromComponents from './components';
import { CommonModule } from '@angular/common';
import { MyOrdersComponent } from '@app/my-orders/my-orders.component';
import { ExcelService } from './services/excel.service';

/**
 * MyOrdersModule
 */
@NgModule({
  imports: [SharedModule, MyOrdersRoutingModule, CommonModule],
  declarations: [MyOrdersComponent, ...fromComponents.components],
  providers: [ExcelService],
  exports: [MyOrdersComponent, ...fromComponents.components],
})
export class MyOrdersModule {}
